<div class="menu no-selected-catalog" *ngIf="catalog === null">No currently selected catalog</div>

<div class="menu bookmarks" *ngIf="catalog !== null">
  <div class="card" [class.active]="currentPageType === 'all'">
    <div role="tab" class="card-header">
      <h5>
        <button class="btn btn-link" [routerLink]="['/', 'bookmarks', 'all', lang]">
          <div class="tab">
            <span class="icon"><i class="fa fa-star"></i></span>
            <span>{{ 'ALL_MY_SAVED_ITEMS' | translate }}</span>
            <span class="bookmark-count" *ngIf="bookmarkCount > 0">{{ bookmarkCount }}</span>
          </div>
        </button>
      </h5>
    </div>
  </div>

  <div class="card" [class.active]="currentPageType === 'news'">
    <div role="tab" class="card-header">
      <h5>
        <button class="btn btn-link" [routerLink]="['/', 'bookmarks', 'news', lang]">
          <div class="tab">
            <span class="icon"><i class="fa fa-newspaper-o"></i></span>
            <span>News</span>
          </div>
        </button>
      </h5>
    </div>
  </div>

  <div class="card" [class.active]="currentPageType === 'agenda'">
    <div role="tab" class="card-header">
      <h5>
        <button class="btn btn-link" [routerLink]="['/', 'bookmarks', 'agenda', lang]">
          <div class="tab">
            <span class="icon"><i class="fa fa-calendar"></i></span>
            <span>Events</span>
          </div>
        </button>
      </h5>
    </div>
  </div>

  <div class="card" [class.active]="currentPageType === 'search'">
    <div role="tab" class="card-header">
      <h5>
        <button class="btn btn-link" [routerLink]="['/', 'bookmarks', 'search', lang]">
          <div class="tab">
            <span class="icon"><i class="fa fa-search"></i></span>
            <span>Search</span>
          </div>
        </button>
      </h5>
    </div>
  </div>
</div>
